import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <div className="nav-brand">
              <Link to="/">
                <i className="fas fa-hands-helping"></i>
                <span>NGO</span>
              </Link>
            </div>
            <div className="social-icons">
              <a href="#" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
              <a href="#" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
              <a href="#" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
            </div>
          </div>

          <div className="footer-pages">
            <h2>Our Pages</h2>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><a href="#about">About</a></li>
              <li><a href="#volenteres">Our Volunteer</a></li>
              <li><a href="#contact">Contact</a></li>
              <li><Link to="/donate">Donate Now</Link></li>
              <li><Link to="/refund-policy">Refund Policy</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
            </ul>
          </div>

          <div className="footer-contact">
            <h2>Contact Now</h2>
            <ul>
              <li>
                <i className="fas fa-map-marker-alt"></i>
                <span>Plot No- 1759, Kaliganj, P.o-arrah, Bidhannagar, Bardhaman, Durgapur Mc, West Bengal, India, 713212</span>
              </li>
              <li>
                <i className="fas fa-phone-volume"></i>
                <span>9475707905</span>
              </li>
              <li>
                <i className="far fa-envelope"></i>
                <span>info@nqa1.in</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-developer">
          <p>Designed by <span>Ruturaj Umale</span> Produced by <span>UGTI INDIA PVT LTD</span></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

